import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'portal.views.broughtToYou.title',
    defaultMessage: 'Brought to you by',
    description: 'Page heading',
  },
  courseDeveloped: {
    id: 'portal.views.broughtToYou.courseDeveloped',
    defaultMessage: 'This course was developed in collaboration between Legatum and '
      + 'the Oxford Character Project, at the University of Oxford, and the Human Flourishing Program, '
      + 'at the institute for Quantitative Social Sciences at Harvard University. A global working group '
      + 'of character and leadership scholar-practitioners also advised on the course structure and content.',
    description: 'Welcome text for Brought to you by page',
  },
  legatumName: {
    id: 'portal.views.broughtToYou.sponsors.legatum.name',
    defaultMessage: 'Legatum',
    description: 'Legatum organization name',
  },
  legatumText: {
    id: 'portal.views.broughtToYou.sponsors.legatum.text',
    defaultMessage: 'Legatum’s ambition is to improve people’s lives by increasing prosperity across the world. '
      + 'To build a better world, we need leaders in all sectors at all levels committed to living out the '
      + 'virtues in their leadership. Legatum supports and creates initiatives that develop leaders of character, '
      + 'supporting individuals on their lifelong journey of personal transformation.',
    description: 'Legatum description',
  },
  oxfordName: {
    id: 'portal.views.broughtToYou.sponsors.oxford.name',
    defaultMessage: 'The Oxford Character Project',
    description: 'Oxford Character Project name',
  },
  oxfordText: {
    id: 'portal.views.broughtToYou.sponsors.oxford.text',
    defaultMessage: 'The Oxford Character Project (OCP) aims to help leaders develop the character they '
      + 'need to navigate the challenges of our time and make an impact for good. Through research and '
      + 'leadership development programmes, OCP enables students and professionals to lead across boundaries '
      + 'and contribute positively to organisations and society.',
    description: 'Oxford Character Project description',
  },
  harvardName: {
    id: 'portal.views.broughtToYou.sponsors.harvard.name',
    defaultMessage: 'Harvard Human Flourishing',
    description: 'Harvard Human Flourishing name',
  },
  harvardText: {
    id: 'portal.views.broughtToYou.sponsors.harvard.text',
    defaultMessage: 'The Human Flourishing Program at Harvard studies and promotes human flourishing '
      + 'through interdisciplinary research, conferences, and programs.',
    description: 'Harvard Human Flourishing description',
  },
});

export default messages;
